export default {
    failedToDownloadFile: {
        en: 'Failed to download file',
        ru: 'Ошибка при скачивании файла',
    },
};
